<template>
  <div>
    <b-sidebar
      id="sidebar-product"
      v-model="showSlide"
      backdrop
      shadow
      backdrop-variant="dark"
      right
      aria-labelledby="sidebar-header-discount-title"
      @hidden="hide()"
      no-header
    >
      <template>
        <div v-if="isLoading">
          <OtherLoading />
        </div>
        <div class="py-3" v-else>
          <label class="ml-2">ส่วนลดท้ายบิล</label>
          <hr class="mb-0" />
          <b-row
            class="mx-0 py-2 border-bottom"
            v-for="(d, index) in headerDiscountOption"
            :key="index"
          >
            <b-col
              cols="2"
              class="d-flex justify-content-center align-items-center"
            >
              <b-form-checkbox
                v-model="discountSelectId"
                :value="d.id"
              ></b-form-checkbox>
            </b-col>
            <b-col cols="6" class="px-2">
              <p>
                <strong>{{ d.id }}</strong>
              </p>
              <p class="text-sub">{{ d.name }}</p>
              <p class="text-sub">
                <u @click="openModalEdit(index)">ปรับส่วนลด</u>
              </p>
            </b-col>
            <b-col cols="4" class="px-2"
              ><p class="float-right text-nowrap">
                {{ d.promotion_value | numeral("0,0.00") }}
                {{ d.promotion_discount_type_id == 1 ? "%" : "บาท" }}
              </p></b-col
            >
          </b-row>
        </div>
      </template>

      <template #footer>
        <div class="text-center">
          <div class="mb-4 w-100">
            <b-button
              class="radius-btn text-white w-75"
              :style="$store.state.backgroundSecondary"
              @click="submitDiscount"
              ><span>เลือก</span></b-button
            >
          </div>
        </div>
      </template>
    </b-sidebar>
  </div>
</template>

<script>
import OtherLoading from "@/components/loading/OtherLoading";
import InputText from "@/components/inputs/InputText";
export default {
  name: "SlideHeaderDiscount",
  components: { OtherLoading, InputText },
  props: {
    headerDiscountSelectIdList: {
      type: Array,
      isRequired: true,
    },
    headerDiscountOption: {
      type: Array,
      isRequired: true,
    },
  },
  data() {
    return {
      showSlide: false,
      discountSelectId: [],
      discountSelectList: [],
      indexEdit: 0,
      valueEdit: 0,
      modalEditHeaderDiscount: false,
      isLoading: false,
    };
  },
  watch: {
    discountSelectId: {
      handler(val) {
        this.discountSelectList = [];
        this.discountSelectId.forEach((d, index) => {
          this.headerDiscountOption.forEach((h, i) => {
            if (d == h.id) {
              this.discountSelectList.push({
                id: h.id,
                custom_header_discount: h.promotion_value,
              });
            }
          });
        });
      },
    },
  },
  methods: {
    async show() {
      this.discountSelectId = this.headerDiscountSelectIdList;
      this.showSlide = true;
    },
    hide() {
      this.showSlide = false;
      this.discountSelectList = [];
    },
    async openModalEdit(index) {
      this.$emit("onOpenEditHeaderDiscountModal", index);
    },
    resetCalculateList() {
      this.discountSelectId.push("update");
      this.discountSelectId.pop();
    },
    async submitDiscount() {
      await this.$emit("onSelectDiscount", {
        detail: this.discountSelectList,
        id: this.discountSelectId,
      });
      this.hide();
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
